import { Button } from "src/elements";
import { useUser } from "src/atoms/user";
import { useTranslation } from "src/i18n";
import { useNavigation } from "src/utils/navigation";
import { pages } from "src/utils/pages";
import { hasPermission, PermissionCode } from "@CommonUtils/RolesPermissions";

interface Props {
  categoryId: number;
  isDisabled?: boolean;
}

export const CdtStudioConfigurationButton = ({ categoryId, isDisabled }: Props) => {
  const { navigate } = useNavigation();
  const { t } = useTranslation("common");
  const { user } = useUser();
  const canEdit = hasPermission(user.roleCode, PermissionCode.CDT_EDIT);

  const openConfiguration = () => {
    navigate(pages.categories_categoryId_cdtStudioConfiguration, { categoryId });
  };

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      size="small"
      isDisabled={isDisabled || !canEdit}
      onClick={openConfiguration}
    >
      {t("cdtStudioTab.configurationLabel")}
    </Button>
  );
};
